<template>
	<section class="_page-count" :data-audio="audio">
		<div v-if="counter" class="g-row-full">
			<div class="counter-count -big-statement -e0">
				<SplitText :text="counter.value" chars :classnames="{ fragment: 'm-t' }" />
			</div>
		</div>

		<div class="line-divider relative">
			<span class="line" />
		</div>

		<div class="g-row s-header">
			<h2 class="g-col xxl-4 xs-24 h3 -p-medium">{{ title }}</h2>
			<p
				class="g-col xxl-7 xxl-offset-12 md-offset-10 md-9 sm-offset-8 sm-12 xs-24 xs-offset-0 -p-small"
			>
				{{ description }}
			</p>
		</div>
	</section>
</template>

<script setup>
import { SplitText } from '@/components/utilities/SplitText'

defineProps({
	counter: {
		type: Object,
		default: () => ({
			value: 528,
		}),
	},
	title: { type: String, default: '' },
	description: { type: String, default: '' },
	audio: { type: Boolean, default: true },
})
</script>

<style lang="scss">
._page-count {
	position: relative;
	margin-top: rs(-100, -100);
	margin-bottom: rs(64, 64);

	@include max-width($xs) {
		margin-top: rs(20, 20);
	}

	.line {
		height: 1px;
		width: 100%;
		background-color: $black;
	}

	.counter-count {
		padding: rs(24, 24) 0;
	}

	& > .s-header {
		margin: rs(24, 24) 0;
		margin-bottom: rs(64, 44);

		@include max-width($xs) {
			h2 {
				margin-bottom: 12px;
			}
		}
	}
}
</style>
